// // ** React Imports
// import { useState, Fragment } from 'react'

// // ** Reactstrap Imports
// import { Card, CardHeader, CardTitle, CardBody, Button, ListGroup, ListGroupItem } from 'reactstrap'

// // ** Third Party Imports
// import toast from 'react-hot-toast'
// import { useDropzone } from 'react-dropzone'
// import { X, DownloadCloud } from 'react-feather'
// import { MdOutlineFileUpload } from "react-icons/md";

// const ImageFileUploader = () => {
//   // ** State
//   const [files, setFiles] = useState([])

//   const { getRootProps, getInputProps } = useDropzone({
//     multiple: false,
//     accept: 'image/*',
//     onDrop: (acceptedFiles, rejectedFiles) => {
//       if (rejectedFiles.length) {
//         toast.error('You can only upload image Files!.')
//       } else {
//         setFiles([...files, ...acceptedFiles.map(file => Object.assign(file))])
//       }
//     }
//   })

//   const handleRemoveFile = file => {
//     const uploadedFiles = files
//     const filtered = uploadedFiles.filter(i => i.name !== file.name)
//     setFiles([...filtered])
//   }

//   const renderFileSize = size => {
//     if (Math.round(size / 100) / 10 > 1000) {
//       return `${(Math.round(size / 100) / 10000).toFixed(1)} mb`
//     } else {
//       return `${(Math.round(size / 100) / 10).toFixed(1)} kb`
//     }
//   }

//   const fileList = files.map((file, index) => (
//     <ListGroupItem key={`${file.name}-${index}`} className='d-flex align-items-center justify-content-between'>
//       <div className='file-details d-flex align-items-center'>
//         <div className='file-preview me-1'>
//           <img className='rounded' alt={file.name} src={URL.createObjectURL(file)} height='28' width='28' />
//         </div>
//         <div>
//           <p className='file-name mb-0'>{file.name}</p>
//           <p className='file-size mb-0'>{renderFileSize(file.size)}</p>
//         </div>
//       </div>
//       <Button color='danger' outline size='sm' className='btn-icon' onClick={() => handleRemoveFile(file)}>
//         <X size={14} />
//       </Button>
//     </ListGroupItem>
//   ))

//   const handleRemoveAllFiles = () => {
//     setFiles([])
//   }

//   return (
//     <Card>
//       <CardBody>
//         <div {...getRootProps({ className: 'dropzone' })}>
//           <input {...getInputProps()} />
//           <div className='d-flex align-items-center justify-content-center flex-column'>
//             <div style={{padding:'0.2rem', backgroundColor:'#eeedf0', borderRadius:'20%'}}>
//                 <MdOutlineFileUpload size={55} color='#8b8d99' />
//             </div>
//             <h5>Drop Files here or click to upload</h5>
//           </div>
//         </div>
//         {files.length ? (
//           <Fragment>
//             <ListGroup className='my-2'>{fileList}</ListGroup>
//             <div className='d-flex justify-content-end'>
//               <Button className='me-1' color='danger' outline onClick={handleRemoveAllFiles}>
//                 Remove All
//               </Button>
//               <Button color='primary'>Upload Files</Button>
//             </div>
//           </Fragment>
//         ) : null}
//       </CardBody>
//     </Card>
//   )
// }

// export default ImageFileUploader


import React, { useState } from 'react';
import { X } from 'react-feather';
import { FaCirclePlus } from 'react-icons/fa6';
import { Button, Input } from 'reactstrap';

const ImageFileUploader = ({ pictures, setPictures, imgs, setImgs, handleRemoveFile  }) => {


  const handleImageChange = (e) => {
    const selectedImages = Array.from(e.target.files);

    if (selectedImages.length > 0) {
      const newPictures = [...pictures, ...selectedImages];
      setPictures(newPictures);

      const imgURLs = newPictures.map((image) => {
        try {
          return URL.createObjectURL(image);
        } catch (error) {
          console.error('Error creating object URL:', error);
          return null;
        }
      }).filter(url => url !== null);

      setImgs(imgURLs);
    }
    e.target.value = '';
  };


  return (
    <>
    {
        console.log('pictures, imgs', pictures, imgs)
    }
      <div style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'row' }}>
        <label style={{
          width: '62px',
          height: '76px',
          margin: '0.5rem',
          backgroundColor: '#F2F2F2',
          borderRadius: '5px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          cursor: 'pointer'
        }}>
          <FaCirclePlus size={21} />
          <Input
            type="file"
            id="pic"
            onChange={handleImageChange}
            placeholder="Select Picture"
            className="inputfile"
            accept="image/png, image/gif, image/jpeg, image/jpg, video/mp4, video/quicktime, video/x-msvideo"
            multiple
            style={{ display: 'none' }}
          />
        </label>
        <div style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'row' }}>
        {imgs.map((fileUrl, index) => (
            <div key={index} style={{
              width: '62px',
              height: '76px',
              margin: '0.5rem',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              borderRadius: '5px',
              position: 'relative'
            }}>
              {fileUrl.match(/\.(mp4|mov|avi)$/) ? (
                <video
                  src={fileUrl}
                  style={{ width: '100%', height: '100%', borderRadius: '5px', objectFit: 'cover' }}
                  controls
                />
              ) : (
                <div style={{
                  width: '100%',
                  height: '100%',
                  backgroundImage: `url(${fileUrl})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  borderRadius: '5px'
                }} />
              )}
              <Button
                color='danger'
                outline
                size='sm'
                className='btn-icon'
                onClick={() => handleRemoveFile(index)}
                style={{ position: 'absolute', top: 0, right: 0 }}
              >
                <X size={14} />
              </Button>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ImageFileUploader;
